import { defaultConfig } from 'app/config/environment';
import { getViewerConfig } from 'app/config/viewerConfig';
import { useAuthUser } from 'app/hooks/useAuthUser';
import { systemSettings } from 'app/store/index';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

export function useViewerContainer() {
  const setting = useSelector((state) => systemSettings.selectors.getSetting(state));
  const isEnableNutrient = !!setting?.enable_nutrient || undefined;
  const isEnableNutrientStandalone = !!setting?.enable_nutrient_standalone || undefined;
  const nutrientLicence = setting?.nutrient_licence || '';
  const { id } = useParams();
  const { authToken, authUser } = useAuthUser();
  const [docConfig, setDocConfig] = useState(undefined);

  useEffect(() => {
    let docConfigViewer = getViewerConfig({ isEnableNutrient, isEnableNutrientStandalone, nutrientLicence });

    setDocConfig(docConfigViewer);
  }, [isEnableNutrient, isEnableNutrientStandalone, nutrientLicence]);

  return {
    id,
    authToken,
    authUser,
    defaultConfig,
    docConfig,
  };
}
